import { CmpsCardRowProgressData } from '@cmps/ng-kit';

import { StagingKpiThreshold } from '../models/staging-kpi-threshold.model';
import { WpCoachingCard } from '../models/wp-coaching-card.model';

import { getWinningPctTooltipData } from './get-progress-tooltip-for-winning-pct.function';

function calculateActualValue(
    score: number,
    lowerThreshold: number,
    upperThreshold: number,
): string {
    if (score <= lowerThreshold) return '0%';
    if (score >= upperThreshold) return '100%';
    return `${(
        ((score - lowerThreshold) / (upperThreshold - lowerThreshold)) *
        100
    ).toFixed(0)}%`;
}

function getRangeColour(
    score: number,
    coachingCardThreshold: StagingKpiThreshold[],
): string {
    const foundThreshold = coachingCardThreshold.find(
        (threshold) =>
            score >= threshold.rangeStart && score <= threshold.rangeEnd,
    );
    return foundThreshold != null ? foundThreshold.rangeColour : '#000000';
}

export function getProgressDataWinningPct(
    wpCoachingCard: WpCoachingCard,
    coachingCardThreshold: StagingKpiThreshold[],
): CmpsCardRowProgressData {
    const thresholdOne =
        coachingCardThreshold != null
            ? wpCoachingCard.winningTarget *
              100 *
              coachingCardThreshold[0].rangeEnd
            : 0;
    const thresholdTwo =
        coachingCardThreshold != null
            ? wpCoachingCard.winningTarget *
              100 *
              coachingCardThreshold[1].rangeEnd
            : 0;
    const score = wpCoachingCard.winning * 100;

    const opportunityColor = getRangeColour(
        wpCoachingCard.winningPercentToTarget,
        coachingCardThreshold,
    );

    const values = [
        {
            thresholdValue: `${thresholdOne.toFixed(0)}%`,
            actualValue: calculateActualValue(score, 0, thresholdOne),
            opportunityColor,
        },
        {
            thresholdValue: `${(thresholdTwo - thresholdOne).toFixed(0)}%`,
            actualValue: calculateActualValue(
                score,
                thresholdOne,
                thresholdTwo,
            ),
            opportunityColor,
        },
        {
            thresholdValue: `${(100 - thresholdTwo).toFixed(0)}%`,
            actualValue: calculateActualValue(score, thresholdTwo, 100),
            opportunityColor,
        },
    ];

    return {
        progressBarValues: values,
        progressTooltipData: getWinningPctTooltipData(wpCoachingCard),
    };
}
